import * as React from 'react'
import { connect } from 'react-redux'
import './../../styles/verify/verificationInput.css'
import {Button} from './../shared/button'
import axios from 'axios'
import {toastr} from 'react-redux-toastr'


class VerificationInput extends React.Component {
  constructor() {
    super()

    this.state = {
      licensePlate: null,
      enterExit: false,
      missingMovement: false,
      longPause: false,
      multipleVehicles: false,
      noVehicles: false,
      submitButtonDisabled: false,
      missingData: false,
      duplicateVideo: false,
      nextVisit: null
    }
  }

  componentDidMount() {
    const next_visit = this.props.verification.sinlgeUnverifiedVisit.next_unverified_visit.id
    this.getNextUnverifiedRecording(next_visit)
  }

  getNextUnverifiedRecording = (next_visit) => {
    let headers = { "Content-Type": "application/json", "Authorization":`JWT ${this.props.auth.token}` }
    axios.get(`/api/verifications/${next_visit}.json`, {headers}).then(results => {
      this.setState({nextVisit: results.data})
    }).catch(error => {
      alert('Error')
    })
  }

  addLicensePlate = (licensePlate) => {
    this.setState({licensePlate: licensePlate})
  }

  toggleEnterExit= () => {
    this.setState({enterExit: !this.state.vehicles})
  }

  toggleMissingMovement = () => {
    this.setState({missingMovement: !this.state.missingMovement})
  }

  toggleLongPause = () => {
    this.setState({longPause: !this.state.longPause})
  }

  toggleMultipleVehicles = () => {
    this.setState({multipleVehicles: !this.state.multipleVehicles})
  }

  toggleNoVehicles = () => {
    this.setState({noVehicles: !this.state.noVehicles})
  }

  toggleMissingData = () => {
    this.setState({missingData: !this.state.missingData})
  }

  toggleDuplicateVideo = () => {
    this.setState({duplicateVideo: !this.state.duplicateVideo})
  }

  jumpToNext = () => {
    toastr.success('Success', 'Verification saved')
    this.props.history.push(`/verification/${this.state.nextVisit.id}/recordings/${this.state.nextVisit.recordings[0].id}`)
  }

  onSubmit = () => {
    const visit = this.props.verification.sinlgeUnverifiedVisit
    this.setState({submitButtonDisabled: true})
    const payload = {
      license_plate_from_verifier: this.state.licensePlate,
      vehicle_entered_and_exited: this.state.enterExit,
      is_missing_movement: this.state.missingMovement,
      is_missing_data: this.state.missingData,
      has_long_pause: this.state.longPause,
      has_multiple_vehicles: this.state.multipleVehicles,
      has_no_vehicles: this.state.noVehicles,
      has_been_verified: true,
      is_duplicate_video: this.state.duplicateVideo
    }
    const { token } = this.props.auth
    axios.patch(
      `/api/verifications/${visit.id}.json`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${token}`
        }
      }
    ).then(response => {
        if(visit.verifier) {
          this.jumpToNext()
        } else {
          this.claimVisit(visit.id)
        }
    }).catch(error => {
      toastr.error('Error', "Couldn't submit verification")
    })
  }

  claimVisit = (visit) => {
    const user = this.props.auth.user.id
    let headers = { "Content-Type": "application/json", "Authorization":`JWT ${this.props.auth.token}` }
    let payload = { verifier: user }
    axios.post(`/api/verifications/${visit}/claim/`, payload, {headers}).then(results => {
      this.jumpToNext()
    }).catch(error => {
      alert('Error')
    })
  }

  render () {
    return (
      <div>
        <div className='verification-input-container'>
          <div className='verify-vehicle'>
              <h3>Verification Input:</h3>
            <div>
              <p>License plate on target vehicle:</p>
              <input onChange={(event) => this.addLicensePlate(event.target.value)} id='licensePlate' />
            </div>
            <div className='verification-input gray'>
              <p>Target vehicle entered and exited the frame:</p>
              <input onClick={() => this.toggleEnterExit()} type='checkbox' id='enterExit'/>
            </div>
            <div className='verification-input'>
              <p>Target vehicle is missing movement:</p>
              <input onClick={() => this.toggleMissingMovement()} type='checkbox' id='missingMovement'/>
            </div>
            <div className='verification-input gray'>
              <p>Target vehicle is missing data:</p>
              <input onClick={() => this.toggleMissingData()} type='checkbox' id='missingData'/>
            </div>
            <div className='verification-input'>
              <p>Target vehicle paused in the frame for a long period:</p>
              <input onClick={() => this.toggleLongPause()} type='checkbox' id='longPause'/>
            </div>
            <div className='verification-input gray'>
              <p>Multiple vehicles in the the frame at the same time:</p>
              <input onClick={() => this.toggleMultipleVehicles()} type='checkbox' id='multipleVehicles'/>
            </div>
            <div className='verification-input'>
              <p>No vehicles enter frame:</p>
              <input onClick={() => this.toggleNoVehicles()} type='checkbox' id='noVehicles'/>
            </div>
            <div className='verification-input gray'>
              <p>Duplicate video:</p>
              <input onClick={() => this.toggleDuplicateVideo()} type='checkbox' id='duplicateVideo'/>
            </div>
          </div>
        </div>
        <Button
          text='Submit'
          disabled={this.state.submitButtonDisabled}
          onClick={() => this.onSubmit()}
          type='note'

        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps)(VerificationInput);



// WEBPACK FOOTER //
// ./src/components/verification/verificationInput.js